<div id="loadingContainer">
	<div id="loading">
		Loading
		<div class="loadingDot" id="dot1"></div>
		<div class="loadingDot" id="dot2"></div>
		<div class="loadingDot" id="dot3"></div>
	</div>
</div>
